import { render, staticRenderFns } from "./FacilitiesFormModal.vue?vue&type=template&id=f63fa81c&scoped=true"
import script from "./FacilitiesFormModal.vue?vue&type=script&lang=ts"
export * from "./FacilitiesFormModal.vue?vue&type=script&lang=ts"
import style0 from "./FacilitiesFormModal.vue?vue&type=style&index=0&id=f63fa81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63fa81c",
  null
  
)

export default component.exports